'use client';

import isProxyDate from './isProxyDate.js';

var validateEmail = function (email) {
    var regExp = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/;
    return regExp.test(String(email).toLowerCase());
};
var validateUrl = function (text) {
    var url;
    try {
        url = new URL(text);
    }
    catch (_) {
        return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
};
var validateNoSpecialChars = function (text) {
    var NO_SPECIAL_CHARS = /[-0-9#@!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/;
    return NO_SPECIAL_CHARS.test(text);
};
var validateNoSpecialCharsWithoutNumber = function (text) {
    var NO_SPECIAL_CHARS = /[#@!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/;
    return NO_SPECIAL_CHARS.test(text);
};
var validateVietNamPhoneNumber = function (value) {
    var getPhoneNumber = value.split('-');
    var VN_PHONE_NUMBER_REGEX = /(^[35789]{1}\d{8}$)|(^0[35789]{1}\d{8}$)/;
    return VN_PHONE_NUMBER_REGEX.test(getPhoneNumber[1]);
};
var validateI11lPhoneNumber = function (value) {
    var getPhoneNumber = value.split('-');
    var I11L_PHONE_NUMBER_REGEX = /^\d[0-9 ]{6,14}$/;
    return I11L_PHONE_NUMBER_REGEX.test(getPhoneNumber[1]);
};
var validateNumber = function (value) {
    var regex = /^\d+$/;
    return regex.test(value);
};
var validateNoSpecialCharsForJobTitle = function (text) {
    var NO_SPECIAL_CHARS = /[@!$%^*()_|~=`{}\[\]:";'<>?,]/;
    return NO_SPECIAL_CHARS.test(text);
};
var validateNoNumberAndEmail = function (text) {
    var NO_NUMBER_EMAIL = /^[^\d]*$/gm;
    return !NO_NUMBER_EMAIL.test(text);
};
var required = function (fieldValue) {
    if (!fieldValue) {
        return false;
    }
    if (Array.isArray(fieldValue) && fieldValue.length === 0) {
        return false;
    }
    if (typeof fieldValue === 'object' &&
        Object.keys(fieldValue).length === 0 &&
        !isProxyDate(fieldValue)) {
        return false;
    }
    var clonedFieldValue = fieldValue;
    if (typeof clonedFieldValue === 'string') {
        clonedFieldValue = clonedFieldValue.trim();
    }
    if (!clonedFieldValue) {
        return false;
    }
    return true;
};
var compareValue = function (value, compareValue) {
    return value >= compareValue;
};
var validateFunctions = {
    validateEmail: validateEmail,
    validateNumber: validateNumber,
    validateUrl: validateUrl,
    validateI11lPhoneNumber: validateI11lPhoneNumber,
    validateVietNamPhoneNumber: validateVietNamPhoneNumber,
    validateNoSpecialChars: validateNoSpecialChars,
    validateNoSpecialCharsWithoutNumber: validateNoSpecialCharsWithoutNumber,
    validateNoSpecialCharsForJobTitle: validateNoSpecialCharsForJobTitle,
    validateNoNumberAndEmail: validateNoNumberAndEmail,
    required: required,
    compareValue: compareValue
};

export { validateFunctions as default };
//# sourceMappingURL=validators.js.map
